module.exports = __webpack_public_path__ + "img/joaquin-urien.81209b8f.jpg";